unit View.Scripts.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  WEBLib.Lists, WEBLib.Grids, Grid.Plugins, UConstantes, System.StrUtils,
  Auth.Service, WEBLib.WebCtrls, Web, UHelperServer, UUtils, UWeb.Enum;

type
  TFViewScriptsEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbusuario_id: TLabel;
    edusuario_nome: TDBEdit;
    lbscript_geral: TLabel;
    XDataClientScriptsGet: TXDataWebClient;
    ScriptsDataset: TXDataWebDataSet;
    ScriptsDatasetid: TIntegerField;
    ScriptsDatasetusuario_id: TIntegerField;
    ScriptsDatasetscript_s3: TStringField;
    ScriptsDatasetscript_geral: TBooleanField;
    ScriptsDatasetinclusao: TDateTimeField;
    WebPanel1: TPanel;
    btnTabScript: TButton;
    cbscript_geral: TComboBox;
    lbscript_tipo: TLabel;
    cbscript_tipo: TComboBox;
    lbscript_texto: TLabel;
    mmscript_texto: TMemo;
    ScriptsDatasetscript_tipo: TIntegerField;
    WebPanel2: TPanel;
    dtsDestinatarios: TDataSource;
    cdsDestinatarios: TXDataWebDataSet;
    cbPageSizeDestinatarios: TComboBox;
    destinatarios_search: TEdit;
    btnDestinatariosTab: TButton;
    tblDestinatarios: TDBTableControl;
    lbTotalDestinatarios: TLabel;
    wlcDestinatarios: TListControl;
    cdsDestinatariosid: TIntegerField;
    cdsDestinatariosscript_id: TIntegerField;
    cdsDestinatariosstatus: TIntegerField;
    cdsDestinatarioserro: TStringField;
    cdsDestinatariosinclusao: TDateTimeField;
    cdsDestinatariosalteracao: TDateTimeField;
    tmrConsultaDestinatarios: TTimer;
    WebPanel3: TPanel;
    dtsAliados: TDataSource;
    cdsAliados: TXDataWebDataSet;
    cbPageSizeAliados: TComboBox;
    aliados_search: TEdit;
    btnAdicionarAliado: TButton;
    tblAliados: TDBTableControl;
    tmrConsultaAliados: TTimer;
    lbTotalAliados: TLabel;
    wlcAliados: TListControl;
    div_campos_visualizar: THTMLDiv;
    lbscript_s3: TLabel;
    edscript_s3: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    XDataWebClientObterScript: TXDataWebClient;
    WebPanel4: TPanel;
    dtsDestinatariosEdit: TDataSource;
    cdsDestinatariosEdit: TXDataWebDataSet;
    tblDestinatariosEdit: TDBTableControl;
    cdsDestinatariosEditscript_id: TIntegerField;
    cdsDestinatariosEditaliado_id: TIntegerField;
    cdsDestinatariosEditdata_base_id: TIntegerField;
    cdsAliadosid: TIntegerField;
    cdsAliadostoken: TStringField;
    cdsAliadosfiscal: TBooleanField;
    cdsAliadosaliado_id: TIntegerField;
    cdsAliadosaliado: TXDataWebEntityField;
    cdsAliadosaliadoNome_Fantasia: TXDataWebDatasetField;
    cdsAliadosaliadoCNPJ: TXDataWebDatasetField;
    cdsAliadospath: TStringField;
    cdsDestinatariosEditnome_fantasia: TStringField;
    cdsDestinatariosEditcnpj: TStringField;
    cdsDestinatariosEdittoken: TStringField;
    cdsDestinatariosEditpath: TStringField;
    ScriptsDatasetusuario: TXDataWebEntityField;
    ScriptsDatasetusuarionome: TXDataWebDatasetField;
    cdsDestinatariosdata_base: TXDataWebEntityField;
    cdsDestinatariosdata_basealiadoNome_Fantasia: TXDataWebDatasetField;
    cdsDestinatariosdata_basealiadoCNPJ: TXDataWebDatasetField;
    cdsDestinatariosdata_basetoken: TXDataWebDatasetField;
    cdsDestinatariosdata_basepath: TXDataWebDatasetField;
    cdsDestinatariosEditfiscal: TStringField;
    cdsDestinatariosdata_execucao: TDateTimeField;
    XDataWebClientReexecutarScript: TXDataWebClient;
    edtScriptErro: TEdit;
    cbbScriptStatus: TComboBox;
    cdsAliadosadicionado: TIntegerField;
    lbnome: TLabel;
    ednome: TDBEdit;
    ScriptsDatasetnome: TStringField;
    ScriptsDatasetscript_versao_minima: TStringField;
    lbscript_versao_minima: TLabel;
    edscript_versao_minima: TDBEdit;
    ScriptsDatasetobservacao: TStringField;
    lbobservacao: TLabel;
    edobservacao: TDBEdit;
    btAdicionarTodos: TButton;
    cbVersaoMinima: TDBComboBox;
    dtsVersoes: TDataSource;
    cdsVersoes: TXDataWebDataSet;
    cdsVersoesnome: TStringField;
    cdsDestinatariosdata_baseid: TXDataWebDatasetField;
    cdsDestinatariosdata_basealiado_id: TXDataWebDatasetField;
    btnListagemBancos: TButton;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientScriptsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientScriptsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientScriptsDeleteError(Error: TXDataClientError);
    procedure ScriptsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure tmrConsultaDestinatariosTimer(Sender: TObject);
    procedure destinatarios_searchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure destinatarios_searchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnDestinatariosTabClick(Sender: TObject);
    procedure tblDestinatariosGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblDestinatariosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure btnAdicionarAliadoClick(Sender: TObject);
    procedure tmrConsultaAliadosTimer(Sender: TObject);
    procedure aliados_searchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure aliados_searchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tblAliadosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure WebFormShow(Sender: TObject);
    procedure cbscript_geralChange(Sender: TObject);
    procedure XDataWebClientObterScriptLoad(Response: TXDataClientResponse);
    procedure tblAliadosGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblDestinatariosEditGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure tblDestinatariosEditGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblAliadosGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblDestinatariosEditGetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tblDestinatariosGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure XDataWebClientReexecutarScriptLoad(Response: TXDataClientResponse);
    procedure XDataWebClientReexecutarScriptError(Error: TXDataClientError);
    procedure XDataWebClientObterScriptError(Error: TXDataClientError);
    procedure cbbScriptStatusChange(Sender: TObject);
    procedure mmscript_textoClick(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
    [async]
    procedure btAdicionarTodosClick(Sender: TObject); async;
    procedure cbPageSizeDestinatariosChange(Sender: TObject);
    procedure cbPageSizeAliadosChange(Sender: TObject);
    procedure cdsVersoesAfterOpen(DataSet: TDataSet);
    procedure cbscript_geralClick(Sender: TObject);
    procedure cbVersaoMinimaClick(Sender: TObject);
    procedure ScriptsDatasetusuarionomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginDestinatarios,
    FGridPluginAliados : TGridPlugin;
    FCarregouDestinatarios,
    FCarregouAliados : Boolean;

    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure ConfigurarScriptExistente;
    procedure ConfigurarNovoScript;
    procedure PreencherScriptId(pScriptId : Integer);
    procedure LimparErros;
    procedure SetErro(pClass, pErro : string);
    function ValidarPost : TArray<string>;
    procedure RemoverErro(pClass : string);
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewScriptsEdit: TFViewScriptsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewScriptsEdit }

procedure TFViewScriptsEdit.btSaveClick(Sender: TObject);
var
  lScriptBase64,
  lErro : TArray<string>;
begin
  lErro := ValidarPost;
  if lErro[0] <> '' then
  begin
    SetErro(lErro[1], lErro[0]);

    Exit;
  end;

  if (cbscript_geral.ItemIndex = 1) then
  begin
    if cdsDestinatariosEdit.IsEmpty then
    begin
      if TUtils.PossuiPermissao(cdsDestinatariosEdit.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
      begin
        TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum destinatário adicionado para receber o script!');
        btnAdicionarAliado.Click;
        asm
          $('#line-adicionar-tab').tab('show');
        end;
      end
      else
      begin
        TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum destinatário adicionado para receber o script!' +
          sLineBreak + 'Verifique as permissões para o usuário.');
      end;

      Exit;
    end;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'cadastrar este script?')) then
  begin
    if ScriptsDataset.State in dsEditModes then
    begin
      ScriptsDataset.FieldByName('script_s3').AsString := window.btoa(mmscript_texto.Text);
      ScriptsDataset.FieldByName('script_geral').AsInteger := (cbscript_geral.ItemIndex - 1);
      ScriptsDataset.FieldByName('script_tipo').AsInteger := cbscript_tipo.ItemIndex;

      if cbVersaoMinima.Text = 'TODAS' then
        ScriptsDataset.FieldByName('script_versao_minima').Value := null
      else
        ScriptsDataset.FieldByName('script_versao_minima').AsString := cbVersaoMinima.Text;

      ScriptsDataset.Post;
      ScriptsDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

procedure TFViewScriptsEdit.cbbScriptStatusChange(Sender: TObject);
var
  lFiltro : string;
begin
  case cbbScriptStatus.ItemIndex of
    0 : lFiltro := 'script_id eq ' + edid.Text;
    1 : lFiltro := '(script_id eq ' + edid.Text+') and (status eq 0)';
    2 : lFiltro := '(script_id eq ' + edid.Text+') and (status eq 1)';
    3 : lFiltro := '(script_id eq ' + edid.Text+') and (status eq 2)';
  end;

  destinatarios_search.Text := EmptyStr;
  cbPageSizeDestinatarios.ItemIndex := 0;

  FGridPluginDestinatarios.FDatasetPlugin.FFilterPadrao := lFiltro;
  FGridPluginDestinatarios.SetPageSize(StrToInt(cbPageSizeDestinatarios.Text));
  FGridPluginDestinatarios.SetFilterText(destinatarios_search.Text);
  FGridPluginDestinatarios.Load;
end;

procedure TFViewScriptsEdit.cbPageSizeAliadosChange(Sender: TObject);
begin
  FGridPluginAliados.SetPageSize(StrToInt(cbPageSizeAliados.Text), True);
end;

procedure TFViewScriptsEdit.cbPageSizeDestinatariosChange(Sender: TObject);
begin
  FGridPluginDestinatarios.SetPageSize(StrToInt(cbPageSizeDestinatarios.Text), True);
end;

procedure TFViewScriptsEdit.cbscript_geralChange(Sender: TObject);
begin
  if TUtils.PossuiPermissao(cdsDestinatariosEdit.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    btnAdicionarAliado.Visible := cbscript_geral.ItemIndex = 1;
    btnAdicionarAliado.Enabled := cbscript_geral.ItemIndex = 1;
  end;
end;

procedure TFViewScriptsEdit.cbscript_geralClick(Sender: TObject);
begin
  RemoverErro('view_scrips_form_lbscript_geral');
end;

procedure TFViewScriptsEdit.cbVersaoMinimaClick(Sender: TObject);
begin
  RemoverErro('view_scrips_form_lbscript_versao_minima');
end;

procedure TFViewScriptsEdit.cdsVersoesAfterOpen(DataSet: TDataSet);
begin
  cdsVersoes.Append;
  cdsVersoes.FieldByName('nome').AsString := '';
  cdsVersoes.Post;

  dtsVersoes.AutoEdit := False;
end;

procedure TFViewScriptsEdit.ConfigurarNovoScript;
begin
  THelperServer.RemoverElementoPorId('line-destinatarios');
  THelperServer.RemoverElementoPorId(btnDestinatariosTab.ElementID);
  THelperServer.RemoverElementoPorId('view.scripts.form.edscript_versao_minima');

  if not TUtils.PossuiPermissao(cdsDestinatariosEdit.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId('modalListagemBancos');
    THelperServer.RemoverElementoPorId(btnAdicionarAliado.ElementID);
    THelperServer.RemoverElementoPorId('line-adicionar');
  end;

  if not TUtils.PossuiPermissao(cdsAliados.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId('modalListagemBancos');
    btnListagemBancos.Enabled := False;
  end;

  btAdicionarTodos.Enabled := TUtils.PossuiPermissao('scripts_aliados', TTipoPermissao.INSERIR);

  if TUtils.PossuiPermissao('versoes', TTipoPermissao.VISUALIZAR) then
    cdsVersoes.Load;

  if ednome.CanFocus then
    ednome.SetFocus;
end;

procedure TFViewScriptsEdit.ConfigurarScriptExistente;
begin
  THelperServer.RemoverElementoPorId('view.scripts.form.cbversao_minima');
  THelperServer.RemoverElementoPorId(btSave.ElementID);
  THelperServer.RemoverElementoPorId('modalListagemBancos');
  THelperServer.RemoverElementoPorId(btnAdicionarAliado.ElementID);
  THelperServer.RemoverElementoPorId('line-adicionar');

  if not TUtils.PossuiPermissao(cdsDestinatarios.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId('line-destinatarios');
    THelperServer.RemoverElementoPorId(btnDestinatariosTab.ElementID);
  end;

  cbscript_geral.Enabled := False;
  cbscript_tipo.Enabled := False;
  mmscript_texto.Enabled := False;
  ednome.Enabled := False;
  edobservacao.Enabled := False;
  div_campos_visualizar.Visible := True;
end;

class function TFViewScriptsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewScriptsEdit.destinatarios_searchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaDestinatarios.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginDestinatarios.SetFilterText(destinatarios_search.Text, True);
  end;
end;

procedure TFViewScriptsEdit.destinatarios_searchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaDestinatarios.Interval := FTimerConsulta;
  tmrConsultaDestinatarios.Enabled := True;
end;

procedure TFViewScriptsEdit.ednomeClick(Sender: TObject);
begin
  RemoverErro('view_scrips_form_lbnome');
end;

procedure TFViewScriptsEdit.HiddenNotification;
begin
  //
end;

procedure TFViewScriptsEdit.InsertEntity;
begin
  ScriptsDataset.Close;
  ScriptsDataset.SetJsonData('{}');
  ScriptsDataset.Open;
  ScriptsDataset.Insert;
end;

class function TFViewScriptsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewScriptsEdit(AForm).FInserting := AInserting;
    TFViewScriptsEdit(AForm).FId := AId;
    TFViewScriptsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewScriptsEdit(AForm).InsertEntity
    else
      TFViewScriptsEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewScriptsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewScriptsEdit.LimparErros;
begin
  asm
    $('.form-text.text-muted.text-danger').hide();
    $('.form-group.has-error').removeClass('has-error');
  end;
end;

procedure TFViewScriptsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ScriptsDataset.Connection.Model.DefaultSchema.FindEntityType(
      ScriptsDataset.EntitySetName
    )
  );
  XDataClientScriptsGet.Get(ScriptsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewScriptsEdit.mmscript_textoClick(Sender: TObject);
begin
  RemoverErro('view_scrips_form_lbscript');
end;

procedure TFViewScriptsEdit.PreencherScriptId(pScriptId: Integer);
begin
  cdsDestinatariosEdit.DisableControls;
  cdsDestinatariosEdit.First;
  try
    while not(cdsDestinatariosEdit.Eof) do
    begin
      cdsDestinatariosEdit.Edit;
      cdsDestinatariosEdit.FieldByName('script_id').AsInteger := pScriptId;
      cdsDestinatariosEdit.Post;

      cdsDestinatariosEdit.Next;
    end;
  finally
    cdsDestinatariosEdit.EnableControls;
  end;
end;

procedure TFViewScriptsEdit.RemoverErro(pClass: string);
var
  lIdErro,
  lDivErro : string;
begin
  lIdErro := pClass + '_error';
  lDivErro := lIdErro + '_div';
  asm
    $('#'+ lIdErro).hide();
    $('#'+ lDivErro).removeClass('has-error');
  end;
end;

procedure TFViewScriptsEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewScriptsEdit.tblAliadosGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordAliadoId,
  RecordDataBaseId : Integer;
  RecordNome,
  RecordCnpj,
  RecordToken,
  RecordPath,
  RecordFiscal : string;
  lAliadoAdicionado : Boolean;

  [async]
  procedure AdicionarAliadoButtonClick(Sender: TObject); async;
  begin
    if cdsDestinatariosEdit.Locate('data_base_id', toInteger(RecordDataBaseId),[loCaseInsensitive,loPartialKey]) then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Banco já esta adicionado a lista de destinatários!');
      Exit;
    end;

    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja adicionar o banco do aliado <b>'+
      UpperCase(RecordNome)+'</b> na lista de destinatários?')) then
    begin
      cdsDestinatariosEdit.Append;
      cdsDestinatariosEdit.FieldByName('aliado_id').AsInteger := RecordAliadoId;
      cdsDestinatariosEdit.FieldByName('data_base_id').AsInteger := RecordDataBaseId;
      cdsDestinatariosEdit.FieldByName('nome_fantasia').AsString := RecordNome;
      cdsDestinatariosEdit.FieldByName('cnpj').AsString := RecordCnpj;
      cdsDestinatariosEdit.FieldByName('token').AsString := RecordToken;
      cdsDestinatariosEdit.FieldByName('path').AsString := RecordPath;
      cdsDestinatariosEdit.FieldByName('fiscal').AsString := RecordFiscal;
      cdsDestinatariosEdit.Post;

      cdsAliados.Edit;
      cdsAliados.FieldByName('adicionado').AsInteger := 1;
      cdsAliados.Post;

      TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Aliado adicionado a lista de destinatários!');
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblAliados.Columns[ACol].Title = 'Ação' then
  begin
    RecordDataBaseId := cdsAliados.FieldByName('id').AsInteger;
    RecordNome := cdsAliados.FieldByName('aliado.Nome_Fantasia').AsString;
    RecordCnpj := cdsAliados.FieldByName('aliado.CNPJ').AsString;
    RecordAliadoId := cdsAliados.FieldByName('aliado_id').AsInteger;
    RecordToken := cdsAliados.FieldByName('token').AsString;
    RecordPath := cdsAliados.FieldByName('path').AsString;
    RecordFiscal := cdsAliados.FieldByName('fiscal').AsString;

    lAliadoAdicionado := cdsDestinatariosEdit.Locate('data_base_id', RecordDataBaseId, []);

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-user-plus"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_vincular_aliado_script');

    if not TUtils.PossuiPermissao('scripts_aliados', TTipoPermissao.INSERIR) or lAliadoAdicionado then
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end
    else
    begin
      Button.OnClick := @AdicionarAliadoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    end;
  end;
end;

procedure TFViewScriptsEdit.tblAliadosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAliados.Columns[ACol].DataField, ['token', 'path',
      'aliado.Nome_Fantasia']) of
      0, 1, 2 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewScriptsEdit.tblAliadosGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    if AValue = 'True' then
      AValue := '<i class="fas fa-check text-success"><i>'
    else if AValue = 'False' then
      AValue := '<i class="fas fa-times text-danger"><i>'
  end;
end;

procedure TFViewScriptsEdit.tblDestinatariosEditGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordDataBaseId : Integer;
  RecordNome : string;
  [async]
  procedure RemoverAliadoButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja remover o banco do aliado <b>'+RecordNome+
      '</b> da lista de destinatários?')) then
    begin
      if cdsDestinatariosEdit.Locate('data_base_id', RecordDataBaseId,[loCaseInsensitive,loPartialKey]) then
      begin
        cdsDestinatariosEdit.Delete;

        cdsAliados.Edit;
        cdsAliados.FieldByName('adicionado').AsInteger := 1;
        cdsAliados.Post;

        TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Banco removido da lista de destinatários!');
      end;
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblDestinatariosEdit.Columns[ACol].Title = 'Ação' then
  begin
    RecordNome := cdsDestinatariosEdit.FieldByName('nome_fantasia').AsString;
    RecordDataBaseId := cdsDestinatariosEdit.FieldByName('data_base_id').AsInteger;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-user-minus"></i>';
    Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
    Button.OnClick := @RemoverAliadoButtonClick;
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_desvincular_aliado_script');
  end;
end;

procedure TFViewScriptsEdit.tblDestinatariosGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordScriptAliadoId,
  RecordScriptErro : string;
  [async]
  procedure ReexecutarScriptButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja reexecutar este script?')) then
    begin
      TUtils.ChamarDivLoading;
      XDataWebClientReexecutarScript.RawInvoke('IScripts_Service.ReexecutarScript', [RecordScriptAliadoId]);
    end;
  end;

  procedure VerErroScriptButtonClick(Sender: TObject);
  begin
    edtScriptErro.Text := RecordScriptErro;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblDestinatarios.Columns[ACol].Title = 'Ações' then
  begin
    RecordScriptAliadoId := cdsDestinatarios.FieldByName('id').AsString;
    RecordScriptErro := cdsDestinatarios.FieldByName('erro').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-retweet"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_reexecutar_script');


    if TUtils.PossuiPermissao('scripts_aliados', TTipoPermissao.ALTERAR) and
      (cdsDestinatarios.FieldByName('status').AsInteger = 2) then
    begin
      Button.OnClick := @ReexecutarScriptButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Reexecutar script');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;


    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-exclamation-triangle"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_scripts_erro');


    if cdsDestinatarios.FieldByName('status').AsInteger = 2 then
    begin
      Button.OnClick := @VerErroScriptButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Erro script');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
      Button.ElementHandle.setAttribute('data-bs-target', '#modal_erro_script');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewScriptsEdit.tblDestinatariosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblDestinatarios.Columns[ACol].Title, ['Aliado',
      'Token Banco', 'Caminho Banco', 'Ações']) of
      0, 1, 2 : AClassName := 'text-left';
      3: AClassName := 'd-flex justify-content-center';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewScriptsEdit.tblDestinatariosGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblDestinatarios.Columns[ACol].DataField, ['status']) of
      0:
      begin
        case StrToInt(AValue) of
          0 : AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Cadastrado</div>';
          1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Executado</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Erro</div>';
        end;
      end;
    end;
  end;
end;

procedure TFViewScriptsEdit.tmrConsultaAliadosTimer(Sender: TObject);
begin
  FGridPluginAliados.SetFilterText(aliados_search.Text, True);

  tmrConsultaAliados.Enabled := False;
  tmrConsultaAliados.Interval := FTimerConsulta;
end;

procedure TFViewScriptsEdit.tmrConsultaDestinatariosTimer(Sender: TObject);
begin
  FGridPluginDestinatarios.SetFilterText(destinatarios_search.Text, True);

  tmrConsultaDestinatarios.Enabled := False;
  tmrConsultaDestinatarios.Interval := FTimerConsulta;
end;

function TFViewScriptsEdit.ValidarPost: TArray<string>;
begin
  LimparErros;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_scrips_form_lbscript';

  if Trim(ednome.Text) = '' then
  begin
    Result[0] := 'Nome do script não pode ser vazio!';
    Result[1] := 'view_scrips_form_lbnome';
  end
  else if Trim(cbVersaoMinima.Text) = '' then
  begin
    Result[0] := 'Informe a versão mínima para execução do script!';
    Result[1] := 'view_scrips_form_lbscript_versao_minima';
  end
  else if Trim(cbscript_geral.Text) = '' then
  begin
    Result[0] := 'Informe os destinatários do script!';
    Result[1] := 'view_scrips_form_lbscript_geral';
  end
  else if Trim(mmscript_texto.Text) = '' then
    Result[0] := 'Script não pode ser vazio!'
  else if not StartsText('SET TERM ^;', UpperCase(Trim(mmscript_texto.Text))) then
    Result[0] := 'Não é possível inserir script sem iniciar com SET TERM ^;'
  else if not EndsText('SET TERM ;^', UpperCase(Trim(mmscript_texto.Text))) then
    Result[0] := 'Não é possível inserir script sem finalizar com SET TERM ;^'
  else if Pos('EXECUTE BLOCK', UpperCase(mmscript_texto.Text)) = 0 then
    Result[0] := 'Não é possível inserir script sem Execute Block!'
  else
  begin
    case cbscript_tipo.ItemIndex of
      1, 2:
      begin
        if Pos('WHERE', UpperCase(mmscript_texto.Text)) = 0 then
          Result[0] := 'Scripts de Delete/Update devem ter o Where!';
      end;
      else
      begin
        if ((Pos('DELETE', UpperCase(mmscript_texto.Text)) > 0) or (Pos('UPDATE', UpperCase(mmscript_texto.Text)) > 0))
          and (Pos('WHERE', UpperCase(mmscript_texto.Text)) = 0) then
        begin
          Result[0] := 'Scripts de Delete/Update devem ter o Where!';
        end;
      end;
    end;
  end;
end;

procedure TFViewScriptsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewScriptsEdit.btnAdicionarAliadoClick(Sender: TObject);
begin
  cdsDestinatariosEdit.Open;

  if TUtils.PossuiPermissao(cdsAliados.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    if not FCarregouAliados then
    begin
      FGridPluginAliados := TGridPlugin.Create(
        tblAliados,
        cdsAliados,
        wlcAliados,
        lbTotalAliados
      );

      FGridPluginAliados.FDatasetPlugin.FOrderByPadrao := 'aliado.Nome_Fantasia';
      FGridPluginAliados.SetPageSize(StrToInt(cbPageSizeAliados.Text));
      FGridPluginAliados.SetFilterText(aliados_search.Text);
      FGridPluginAliados.Load;

      FCarregouAliados := True;
    end;
  end;
end;

procedure TFViewScriptsEdit.btnDestinatariosTabClick(Sender: TObject);
begin
  if not FCarregouDestinatarios then
  begin
    FGridPluginDestinatarios := TGridPlugin.Create(
      tblDestinatarios,
      cdsDestinatarios,
      wlcDestinatarios,
      lbTotalDestinatarios
    );

    FGridPluginDestinatarios.FDatasetPlugin.FFilterPadrao := 'script_id eq ' + edid.Text;
    FGridPluginDestinatarios.FDatasetPlugin.FOrderByPadrao := 'data_base.aliado.Nome_Fantasia asc, status desc';
    FGridPluginDestinatarios.SetPageSize(StrToInt(cbPageSizeDestinatarios.Text));
    FGridPluginDestinatarios.SetFilterText(destinatarios_search.Text);
    FGridPluginDestinatarios.Load;

    FCarregouDestinatarios := True;
  end;
end;

procedure TFViewScriptsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
  FCarregouDestinatarios := False;
  FCarregouAliados := False;

  btnAdicionarAliado.Visible := False;
  btnAdicionarAliado.Enabled := False;

  if TUtils.PossuiPermissao(cdsAliados.EntitySetName, TTipoPermissao.VISUALIZAR) then
    TUtils.RemoverElementoPorId('modalListagemBancosLabel');
end;

procedure TFViewScriptsEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    ConfigurarNovoScript
  else
    ConfigurarScriptExistente;
end;

procedure TFViewScriptsEdit.XDataClientScriptsGetLoad(Response: TXDataClientResponse);
begin
  ScriptsDataset.Close;
  ScriptsDataset.SetJsonData(Response.Result);
  ScriptsDataset.Open;

  cbscript_geral.ItemIndex := (ScriptsDataset.FieldByName('script_geral').AsInteger + 1);
  cbscript_tipo.ItemIndex := ScriptsDataset.FieldByName('script_tipo').AsInteger;

  if ScriptsDataset.FieldByName('script_versao_minima').AsString = '' then
    edscript_versao_minima.Text := 'TODAS';

  XDataWebClientObterScript.RawInvoke('IScripts_Service.ObterScript', [ScriptsDataset.FieldByName('id').AsString]);
end;

procedure TFViewScriptsEdit.XDataWebClientReexecutarScriptError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Não foi possível reexecutar o script!' + SlineBreak +
    Error.ErrorMessage);
end;

procedure TFViewScriptsEdit.XDataWebClientReexecutarScriptLoad(Response: TXDataClientResponse);
begin
  TUtils.OcultarDivLoading;
  FGridPluginDestinatarios.Load;
end;

procedure TFViewScriptsEdit.XDataWebClientObterScriptError(
  Error: TXDataClientError);
begin
  mmscript_texto.Text := 'Não foi possível carregar o script';
end;

procedure TFViewScriptsEdit.XDataWebClientObterScriptLoad(
  Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := TJSObject(TJSJSON.ParseObject(Response.ResponseText));
  mmscript_texto.Text := window.atob(string(lJSONObject['base_64']));
end;

procedure TFViewScriptsEdit.XDataClientScriptsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewScriptsEdit.XDataClientScriptsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewScriptsEdit.ScriptsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
  lScriptId : Integer;
  lDataObject: TJSObject;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
        SetErro('view_scrips_form_lbnome', 'Já existe algum script cadastrado com este nome!')
      else
        ShowNotification(ResolveInfo.Error);

      ScriptsDataset.Edit;

      Exit;
    end
    else
    begin
      if (cbscript_geral.ItemIndex = 1) and FInserting then
      begin
        lDataObject := TJSObject(ResolveInfo.Data);
        lScriptId := Integer(lDataObject.Properties['id']);
        PreencherScriptId(lScriptId);
        cdsDestinatariosEdit.Edit;
        cdsDestinatariosEdit.ApplyUpdates;
      end;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Script salvo com sucesso!');
  FShowListProc;
end;

procedure TFViewScriptsEdit.ScriptsDatasetusuarionomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if FInserting then
    Text := TUtils.FUsuario.Nome
  else
    Text := ScriptsDataset.FieldByName('usuario.nome').AsString;
end;

procedure TFViewScriptsEdit.SetErro(pClass, pErro: string);
var
  lIdErro,
  lDivErro : string;
begin
  lIdErro := pClass + '_error';
  lDivErro := lIdErro + '_div';
  asm
    $('#'+ lIdErro).text(pErro);
    $('#'+ lIdErro).show();
    $('#'+ lDivErro).addClass('has-error');
  end;
end;

procedure TFViewScriptsEdit.aliados_searchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaAliados.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginAliados.SetFilterText(aliados_search.Text, True);
  end;
end;

procedure TFViewScriptsEdit.aliados_searchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaAliados.Interval := FTimerConsulta;
  tmrConsultaAliados.Enabled := True;
end;

procedure TFViewScriptsEdit.btAdicionarTodosClick(Sender: TObject);
var
  lIndice,
  lDataBaseId : Integer;
begin
  if cdsAliados.IsEmpty then
    Exit;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
    'Somente os bancos dos aliados listados na <b>página atual</b> serão adicionados!' +
      slineBreak + 'Deseja continuar?')) then
  begin
    lIndice := cdsAliados.RecNo;
    cdsAliados.DisableControls;
    cdsAliados.First;

    try
      while not(cdsAliados.Eof) do
      begin
        lDataBaseId := cdsAliados.FieldByName('id').AsInteger;

        if not cdsDestinatariosEdit.Locate('data_base_id', toInteger(lDataBaseId),[loCaseInsensitive,loPartialKey]) then
        begin
          cdsDestinatariosEdit.Append;

          cdsDestinatariosEdit.FieldByName('aliado_id').AsInteger := cdsAliados.FieldByName('aliado_id').AsInteger;
          cdsDestinatariosEdit.FieldByName('data_base_id').AsInteger := lDataBaseId;
          cdsDestinatariosEdit.FieldByName('nome_fantasia').AsString := cdsAliados.FieldByName('aliado.Nome_Fantasia').AsString;
          cdsDestinatariosEdit.FieldByName('cnpj').AsString := cdsAliados.FieldByName('aliado.CNPJ').AsString;
          cdsDestinatariosEdit.FieldByName('token').AsString := cdsAliados.FieldByName('token').AsString;
          cdsDestinatariosEdit.FieldByName('path').AsString := cdsAliados.FieldByName('path').AsString;
          cdsDestinatariosEdit.FieldByName('fiscal').AsString := cdsAliados.FieldByName('fiscal').AsString;

          cdsDestinatariosEdit.Post;

          cdsAliados.Edit;
          cdsAliados.FieldByName('adicionado').AsInteger := 1;
          cdsAliados.Post;
        end;

        cdsAliados.Next;
      end;
    finally
      cdsAliados.RecNo := lIndice;
      cdsAliados.EnableControls;
    end;

    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Aliados adicionados a lista de destinatários!');
  end;
end;

procedure TFViewScriptsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewScriptsEdit.tblDestinatariosEditGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAliados.Columns[ACol].DataField, ['token', 'path',
      'nome_fantasia']) of
      0, 1, 2 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewScriptsEdit.tblDestinatariosEditGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    if AValue = 'True' then
      AValue := '<i class="fas fa-check text-success"><i>'
    else if AValue = 'False' then
      AValue := '<i class="fas fa-times text-danger"><i>'
  end;
end;

procedure TFViewScriptsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.scripts.form.lbid');
  lbusuario_id := TLabel.Create('view.scripts.form.lbusuario_id');
  lbscript_geral := TLabel.Create('view.scripts.form.lbscript_geral');
  lbscript_tipo := TLabel.Create('view.scripts.form.lbscript_tipo');
  lbscript_texto := TLabel.Create('view.scripts.form.lbscript_texto');
  lbTotalDestinatarios := TLabel.Create('destinatarios_paginacao_info');
  lbTotalAliados := TLabel.Create('aliados_paginacao_info');
  lbnome := TLabel.Create('view.scripts.form.lbnome');
  lbscript_versao_minima := TLabel.Create('view.scripts.form.lbscript_versao_minima');
  lbobservacao := TLabel.Create('view.scripts.form.lbobservacao');
  btCancel := TButton.Create('view.scripts.form.btBack');
  btSave := TButton.Create('view.scripts.form.btSave');
  edid := TDBEdit.Create('view.scripts.form.edid');
  edusuario_nome := TDBEdit.Create('view.scripts.form.edusuario_nome');
  WebPanel1 := TPanel.Create(Self);
  btnTabScript := TButton.Create('line-script-tab');
  cbscript_geral := TComboBox.Create('view.scripts.form.cbscript_geral');
  cbscript_tipo := TComboBox.Create('view.scripts.form.cbscript_tipo');
  mmscript_texto := TMemo.Create('view.scripts.form.mmscript_texto');
  WebPanel2 := TPanel.Create(Self);
  cbPageSizeDestinatarios := TComboBox.Create('destinatarios_page_size');
  destinatarios_search := TEdit.Create('destinatarios_search');
  btnDestinatariosTab := TButton.Create('line-destinatarios-tab');
  tblDestinatarios := TDBTableControl.Create('destinatarios_table');
  wlcDestinatarios := TListControl.Create('destinatarios_list_paginacao');
  WebPanel3 := TPanel.Create(Self);
  cbPageSizeAliados := TComboBox.Create('aliados_page_size');
  aliados_search := TEdit.Create('aliados_search');
  btnAdicionarAliado := TButton.Create('line-adicionar-tab');
  tblAliados := TDBTableControl.Create('aliados_table');
  wlcAliados := TListControl.Create('aliados_list_paginacao');
  div_campos_visualizar := THTMLDiv.Create('div_campos_visualizar');
  lbscript_s3 := TLabel.Create('view.scripts.form.lbscript_s3');
  lbinclusao := TLabel.Create('view.scripts.form.lbinclusao');
  edscript_s3 := TDBEdit.Create('view.scripts.form.edscript_s3');
  edinclusao := TDBEdit.Create('view.scripts.form.edinclusao');
  WebPanel4 := TPanel.Create(Self);
  tblDestinatariosEdit := TDBTableControl.Create('destinatarios_edit_table');
  edtScriptErro := TEdit.Create('edt_script_erro');
  cbbScriptStatus := TComboBox.Create('script_status');
  ednome := TDBEdit.Create('view.scripts.form.ednome');
  edscript_versao_minima := TDBEdit.Create('view.scripts.form.edscript_versao_minima');
  edobservacao := TDBEdit.Create('view.scripts.form.edobservacao');
  btAdicionarTodos := TButton.Create('view.scripts.add.todos');
  cbVersaoMinima := TDBComboBox.Create('view.scripts.form.cbversao_minima');
  btnListagemBancos := TButton.Create('btnListagemBancos');
  DataSource := TDataSource.Create(Self);
  ScriptsDataset := TXDataWebDataSet.Create(Self);
  ScriptsDatasetid := TIntegerField.Create(Self);
  ScriptsDatasetusuario_id := TIntegerField.Create(Self);
  ScriptsDatasetscript_s3 := TStringField.Create(Self);
  ScriptsDatasetscript_geral := TBooleanField.Create(Self);
  ScriptsDatasetinclusao := TDateTimeField.Create(Self);
  ScriptsDatasetscript_tipo := TIntegerField.Create(Self);
  ScriptsDatasetusuario := TXDataWebEntityField.Create(Self);
  ScriptsDatasetusuarionome := TXDataWebDatasetField.Create(Self);
  ScriptsDatasetnome := TStringField.Create(Self);
  ScriptsDatasetscript_versao_minima := TStringField.Create(Self);
  ScriptsDatasetobservacao := TStringField.Create(Self);
  XDataClientScriptsGet := TXDataWebClient.Create(Self);
  dtsDestinatarios := TDataSource.Create(Self);
  cdsDestinatarios := TXDataWebDataSet.Create(Self);
  cdsDestinatariosid := TIntegerField.Create(Self);
  cdsDestinatariosscript_id := TIntegerField.Create(Self);
  cdsDestinatariosstatus := TIntegerField.Create(Self);
  cdsDestinatarioserro := TStringField.Create(Self);
  cdsDestinatariosinclusao := TDateTimeField.Create(Self);
  cdsDestinatariosalteracao := TDateTimeField.Create(Self);
  cdsDestinatariosdata_base := TXDataWebEntityField.Create(Self);
  cdsDestinatariosdata_basealiadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  cdsDestinatariosdata_basealiadoCNPJ := TXDataWebDatasetField.Create(Self);
  cdsDestinatariosdata_basetoken := TXDataWebDatasetField.Create(Self);
  cdsDestinatariosdata_basepath := TXDataWebDatasetField.Create(Self);
  cdsDestinatariosdata_execucao := TDateTimeField.Create(Self);
  cdsDestinatariosdata_baseid := TXDataWebDatasetField.Create(Self);
  cdsDestinatariosdata_basealiado_id := TXDataWebDatasetField.Create(Self);
  tmrConsultaDestinatarios := TTimer.Create(Self);
  dtsAliados := TDataSource.Create(Self);
  cdsAliados := TXDataWebDataSet.Create(Self);
  cdsAliadosid := TIntegerField.Create(Self);
  cdsAliadostoken := TStringField.Create(Self);
  cdsAliadosfiscal := TBooleanField.Create(Self);
  cdsAliadosaliado_id := TIntegerField.Create(Self);
  cdsAliadosaliado := TXDataWebEntityField.Create(Self);
  cdsAliadosaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  cdsAliadosaliadoCNPJ := TXDataWebDatasetField.Create(Self);
  cdsAliadospath := TStringField.Create(Self);
  cdsAliadosadicionado := TIntegerField.Create(Self);
  tmrConsultaAliados := TTimer.Create(Self);
  XDataWebClientObterScript := TXDataWebClient.Create(Self);
  dtsDestinatariosEdit := TDataSource.Create(Self);
  cdsDestinatariosEdit := TXDataWebDataSet.Create(Self);
  cdsDestinatariosEditscript_id := TIntegerField.Create(Self);
  cdsDestinatariosEditaliado_id := TIntegerField.Create(Self);
  cdsDestinatariosEditdata_base_id := TIntegerField.Create(Self);
  cdsDestinatariosEditnome_fantasia := TStringField.Create(Self);
  cdsDestinatariosEditcnpj := TStringField.Create(Self);
  cdsDestinatariosEdittoken := TStringField.Create(Self);
  cdsDestinatariosEditpath := TStringField.Create(Self);
  cdsDestinatariosEditfiscal := TStringField.Create(Self);
  XDataWebClientReexecutarScript := TXDataWebClient.Create(Self);
  dtsVersoes := TDataSource.Create(Self);
  cdsVersoes := TXDataWebDataSet.Create(Self);
  cdsVersoesnome := TStringField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbusuario_id.BeforeLoadDFMValues;
  lbscript_geral.BeforeLoadDFMValues;
  lbscript_tipo.BeforeLoadDFMValues;
  lbscript_texto.BeforeLoadDFMValues;
  lbTotalDestinatarios.BeforeLoadDFMValues;
  lbTotalAliados.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbscript_versao_minima.BeforeLoadDFMValues;
  lbobservacao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edusuario_nome.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnTabScript.BeforeLoadDFMValues;
  cbscript_geral.BeforeLoadDFMValues;
  cbscript_tipo.BeforeLoadDFMValues;
  mmscript_texto.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  cbPageSizeDestinatarios.BeforeLoadDFMValues;
  destinatarios_search.BeforeLoadDFMValues;
  btnDestinatariosTab.BeforeLoadDFMValues;
  tblDestinatarios.BeforeLoadDFMValues;
  wlcDestinatarios.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  cbPageSizeAliados.BeforeLoadDFMValues;
  aliados_search.BeforeLoadDFMValues;
  btnAdicionarAliado.BeforeLoadDFMValues;
  tblAliados.BeforeLoadDFMValues;
  wlcAliados.BeforeLoadDFMValues;
  div_campos_visualizar.BeforeLoadDFMValues;
  lbscript_s3.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edscript_s3.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  tblDestinatariosEdit.BeforeLoadDFMValues;
  edtScriptErro.BeforeLoadDFMValues;
  cbbScriptStatus.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edscript_versao_minima.BeforeLoadDFMValues;
  edobservacao.BeforeLoadDFMValues;
  btAdicionarTodos.BeforeLoadDFMValues;
  cbVersaoMinima.BeforeLoadDFMValues;
  btnListagemBancos.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ScriptsDataset.BeforeLoadDFMValues;
  ScriptsDatasetid.BeforeLoadDFMValues;
  ScriptsDatasetusuario_id.BeforeLoadDFMValues;
  ScriptsDatasetscript_s3.BeforeLoadDFMValues;
  ScriptsDatasetscript_geral.BeforeLoadDFMValues;
  ScriptsDatasetinclusao.BeforeLoadDFMValues;
  ScriptsDatasetscript_tipo.BeforeLoadDFMValues;
  ScriptsDatasetusuario.BeforeLoadDFMValues;
  ScriptsDatasetusuarionome.BeforeLoadDFMValues;
  ScriptsDatasetnome.BeforeLoadDFMValues;
  ScriptsDatasetscript_versao_minima.BeforeLoadDFMValues;
  ScriptsDatasetobservacao.BeforeLoadDFMValues;
  XDataClientScriptsGet.BeforeLoadDFMValues;
  dtsDestinatarios.BeforeLoadDFMValues;
  cdsDestinatarios.BeforeLoadDFMValues;
  cdsDestinatariosid.BeforeLoadDFMValues;
  cdsDestinatariosscript_id.BeforeLoadDFMValues;
  cdsDestinatariosstatus.BeforeLoadDFMValues;
  cdsDestinatarioserro.BeforeLoadDFMValues;
  cdsDestinatariosinclusao.BeforeLoadDFMValues;
  cdsDestinatariosalteracao.BeforeLoadDFMValues;
  cdsDestinatariosdata_base.BeforeLoadDFMValues;
  cdsDestinatariosdata_basealiadoNome_Fantasia.BeforeLoadDFMValues;
  cdsDestinatariosdata_basealiadoCNPJ.BeforeLoadDFMValues;
  cdsDestinatariosdata_basetoken.BeforeLoadDFMValues;
  cdsDestinatariosdata_basepath.BeforeLoadDFMValues;
  cdsDestinatariosdata_execucao.BeforeLoadDFMValues;
  cdsDestinatariosdata_baseid.BeforeLoadDFMValues;
  cdsDestinatariosdata_basealiado_id.BeforeLoadDFMValues;
  tmrConsultaDestinatarios.BeforeLoadDFMValues;
  dtsAliados.BeforeLoadDFMValues;
  cdsAliados.BeforeLoadDFMValues;
  cdsAliadosid.BeforeLoadDFMValues;
  cdsAliadostoken.BeforeLoadDFMValues;
  cdsAliadosfiscal.BeforeLoadDFMValues;
  cdsAliadosaliado_id.BeforeLoadDFMValues;
  cdsAliadosaliado.BeforeLoadDFMValues;
  cdsAliadosaliadoNome_Fantasia.BeforeLoadDFMValues;
  cdsAliadosaliadoCNPJ.BeforeLoadDFMValues;
  cdsAliadospath.BeforeLoadDFMValues;
  cdsAliadosadicionado.BeforeLoadDFMValues;
  tmrConsultaAliados.BeforeLoadDFMValues;
  XDataWebClientObterScript.BeforeLoadDFMValues;
  dtsDestinatariosEdit.BeforeLoadDFMValues;
  cdsDestinatariosEdit.BeforeLoadDFMValues;
  cdsDestinatariosEditscript_id.BeforeLoadDFMValues;
  cdsDestinatariosEditaliado_id.BeforeLoadDFMValues;
  cdsDestinatariosEditdata_base_id.BeforeLoadDFMValues;
  cdsDestinatariosEditnome_fantasia.BeforeLoadDFMValues;
  cdsDestinatariosEditcnpj.BeforeLoadDFMValues;
  cdsDestinatariosEdittoken.BeforeLoadDFMValues;
  cdsDestinatariosEditpath.BeforeLoadDFMValues;
  cdsDestinatariosEditfiscal.BeforeLoadDFMValues;
  XDataWebClientReexecutarScript.BeforeLoadDFMValues;
  dtsVersoes.BeforeLoadDFMValues;
  cdsVersoes.BeforeLoadDFMValues;
  cdsVersoesnome.BeforeLoadDFMValues;
  try
    Name := 'FViewScriptsEdit';
    Width := 1107;
    Height := 605;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 32;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbusuario_id.SetParentComponent(Self);
    lbusuario_id.Name := 'lbusuario_id';
    lbusuario_id.Left := 8;
    lbusuario_id.Top := 59;
    lbusuario_id.Width := 31;
    lbusuario_id.Height := 13;
    lbusuario_id.Caption := 'Autor:';
    lbusuario_id.HeightPercent := 100.000000000000000000;
    lbusuario_id.WidthPercent := 100.000000000000000000;
    lbscript_geral.SetParentComponent(Self);
    lbscript_geral.Name := 'lbscript_geral';
    lbscript_geral.Left := 8;
    lbscript_geral.Top := 143;
    lbscript_geral.Width := 62;
    lbscript_geral.Height := 13;
    lbscript_geral.Caption := 'Destinat'#225'rio:';
    lbscript_geral.HeightPercent := 100.000000000000000000;
    lbscript_geral.WidthPercent := 100.000000000000000000;
    lbscript_tipo.SetParentComponent(Self);
    lbscript_tipo.Name := 'lbscript_tipo';
    lbscript_tipo.Left := 8;
    lbscript_tipo.Top := 167;
    lbscript_tipo.Width := 24;
    lbscript_tipo.Height := 13;
    lbscript_tipo.Caption := 'Tipo:';
    lbscript_tipo.HeightPercent := 100.000000000000000000;
    lbscript_tipo.WidthPercent := 100.000000000000000000;
    lbscript_texto.SetParentComponent(Self);
    lbscript_texto.Name := 'lbscript_texto';
    lbscript_texto.Left := 8;
    lbscript_texto.Top := 194;
    lbscript_texto.Width := 31;
    lbscript_texto.Height := 13;
    lbscript_texto.Caption := 'Script:';
    lbscript_texto.HeightPercent := 100.000000000000000000;
    lbscript_texto.WidthPercent := 100.000000000000000000;
    lbTotalDestinatarios.SetParentComponent(Self);
    lbTotalDestinatarios.Name := 'lbTotalDestinatarios';
    lbTotalDestinatarios.Left := 344;
    lbTotalDestinatarios.Top := 239;
    lbTotalDestinatarios.Width := 141;
    lbTotalDestinatarios.Height := 13;
    lbTotalDestinatarios.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalDestinatarios.HeightPercent := 100.000000000000000000;
    lbTotalDestinatarios.WidthPercent := 100.000000000000000000;
    lbTotalAliados.SetParentComponent(Self);
    lbTotalAliados.Name := 'lbTotalAliados';
    lbTotalAliados.Left := 737;
    lbTotalAliados.Top := 295;
    lbTotalAliados.Width := 141;
    lbTotalAliados.Height := 13;
    lbTotalAliados.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalAliados.HeightPercent := 100.000000000000000000;
    lbTotalAliados.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 10;
    lbnome.Top := 225;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbscript_versao_minima.SetParentComponent(Self);
    lbscript_versao_minima.Name := 'lbscript_versao_minima';
    lbscript_versao_minima.Left := 10;
    lbscript_versao_minima.Top := 252;
    lbscript_versao_minima.Width := 72;
    lbscript_versao_minima.Height := 13;
    lbscript_versao_minima.Caption := 'Vers'#227'o M'#237'nima:';
    lbscript_versao_minima.HeightPercent := 100.000000000000000000;
    lbscript_versao_minima.WidthPercent := 100.000000000000000000;
    lbobservacao.SetParentComponent(Self);
    lbobservacao.Name := 'lbobservacao';
    lbobservacao.Left := 178;
    lbobservacao.Top := 61;
    lbobservacao.Width := 62;
    lbobservacao.Height := 13;
    lbobservacao.Caption := 'Observa'#231#227'o:';
    lbobservacao.HeightPercent := 100.000000000000000000;
    lbobservacao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 110;
    btCancel.Top := 289;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 8;
    btSave.Top := 289;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 45;
    edid.Top := 29;
    edid.Width := 121;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edusuario_nome.SetParentComponent(Self);
    edusuario_nome.Name := 'edusuario_nome';
    edusuario_nome.Left := 43;
    edusuario_nome.Top := 56;
    edusuario_nome.Width := 123;
    edusuario_nome.Height := 21;
    edusuario_nome.Enabled := False;
    edusuario_nome.HeightPercent := 100.000000000000000000;
    edusuario_nome.TabOrder := 7;
    edusuario_nome.Text := 'edusuario_nome';
    edusuario_nome.WidthPercent := 100.000000000000000000;
    edusuario_nome.DataField := 'usuario.nome';
    edusuario_nome.DataSource := DataSource;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 8;
    WebPanel1.Width := 305;
    WebPanel1.Height := 17;
    WebPanel1.Caption := 'Espa'#231'o form script';
    WebPanel1.ChildOrder := 23;
    WebPanel1.Color := clInfoText;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWhite;
    WebPanel1.Font.Height := -11;
    WebPanel1.Font.Name := 'Tahoma';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 4;
    WebPanel1.Visible := False;
    btnTabScript.SetParentComponent(Self);
    btnTabScript.Name := 'btnTabScript';
    btnTabScript.Left := 172;
    btnTabScript.Top := 27;
    btnTabScript.Width := 141;
    btnTabScript.Height := 25;
    btnTabScript.Caption := 'Script';
    btnTabScript.ChildOrder := 16;
    btnTabScript.HeightPercent := 100.000000000000000000;
    btnTabScript.WidthPercent := 100.000000000000000000;
    cbscript_geral.SetParentComponent(Self);
    cbscript_geral.Name := 'cbscript_geral';
    cbscript_geral.Left := 74;
    cbscript_geral.Top := 140;
    cbscript_geral.Width := 92;
    cbscript_geral.Height := 21;
    cbscript_geral.HeightPercent := 100.000000000000000000;
    cbscript_geral.WidthPercent := 100.000000000000000000;
    SetEvent(cbscript_geral, Self, 'OnChange', 'cbscript_geralChange');
    SetEvent(cbscript_geral, Self, 'OnClick', 'cbscript_geralClick');
    cbscript_geral.ItemIndex := 0;
    cbscript_geral.Items.BeginUpdate;
    try
      cbscript_geral.Items.Clear;
      cbscript_geral.Items.Add('');
      cbscript_geral.Items.Add('PERSONALIZADO');
      cbscript_geral.Items.Add('GERAL');
    finally
      cbscript_geral.Items.EndUpdate;
    end;
    cbscript_tipo.SetParentComponent(Self);
    cbscript_tipo.Name := 'cbscript_tipo';
    cbscript_tipo.Left := 74;
    cbscript_tipo.Top := 164;
    cbscript_tipo.Width := 92;
    cbscript_tipo.Height := 21;
    cbscript_tipo.HeightPercent := 100.000000000000000000;
    cbscript_tipo.Text := 'INSERT';
    cbscript_tipo.WidthPercent := 100.000000000000000000;
    cbscript_tipo.ItemIndex := 0;
    cbscript_tipo.Items.BeginUpdate;
    try
      cbscript_tipo.Items.Clear;
      cbscript_tipo.Items.Add('INSERT');
      cbscript_tipo.Items.Add('UPDATE');
      cbscript_tipo.Items.Add('DELETE');
      cbscript_tipo.Items.Add('ALTER');
      cbscript_tipo.Items.Add('CREATE');
    finally
      cbscript_tipo.Items.EndUpdate;
    end;
    mmscript_texto.SetParentComponent(Self);
    mmscript_texto.Name := 'mmscript_texto';
    mmscript_texto.Left := 67;
    mmscript_texto.Top := 191;
    mmscript_texto.Width := 113;
    mmscript_texto.Height := 25;
    mmscript_texto.HeightPercent := 100.000000000000000000;
    mmscript_texto.SelLength := 0;
    mmscript_texto.SelStart := 0;
    mmscript_texto.WidthPercent := 100.000000000000000000;
    SetEvent(mmscript_texto, Self, 'OnClick', 'mmscript_textoClick');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 344;
    WebPanel2.Top := 8;
    WebPanel2.Width := 353;
    WebPanel2.Height := 17;
    WebPanel2.Caption := 'Espa'#231'o tabela destinat'#225'rios';
    WebPanel2.ChildOrder := 23;
    WebPanel2.Color := clInfoText;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWhite;
    WebPanel2.Font.Height := -11;
    WebPanel2.Font.Name := 'Tahoma';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 9;
    WebPanel2.Visible := False;
    cbPageSizeDestinatarios.SetParentComponent(Self);
    cbPageSizeDestinatarios.Name := 'cbPageSizeDestinatarios';
    cbPageSizeDestinatarios.Left := 496;
    cbPageSizeDestinatarios.Top := 32;
    cbPageSizeDestinatarios.Width := 81;
    cbPageSizeDestinatarios.Height := 21;
    cbPageSizeDestinatarios.HeightPercent := 100.000000000000000000;
    cbPageSizeDestinatarios.TabOrder := 2;
    cbPageSizeDestinatarios.Text := '10';
    cbPageSizeDestinatarios.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeDestinatarios, Self, 'OnChange', 'cbPageSizeDestinatariosChange');
    cbPageSizeDestinatarios.ItemIndex := 0;
    cbPageSizeDestinatarios.Items.BeginUpdate;
    try
      cbPageSizeDestinatarios.Items.Clear;
      cbPageSizeDestinatarios.Items.Add('10');
      cbPageSizeDestinatarios.Items.Add('25');
      cbPageSizeDestinatarios.Items.Add('50');
      cbPageSizeDestinatarios.Items.Add('100');
    finally
      cbPageSizeDestinatarios.Items.EndUpdate;
    end;
    destinatarios_search.SetParentComponent(Self);
    destinatarios_search.Name := 'destinatarios_search';
    destinatarios_search.Left := 496;
    destinatarios_search.Top := 59;
    destinatarios_search.Width := 81;
    destinatarios_search.Height := 21;
    destinatarios_search.ChildOrder := 21;
    destinatarios_search.HeightPercent := 100.000000000000000000;
    destinatarios_search.TabOrder := 3;
    destinatarios_search.WidthPercent := 100.000000000000000000;
    SetEvent(destinatarios_search, Self, 'OnKeyDown', 'destinatarios_searchKeyDown');
    SetEvent(destinatarios_search, Self, 'OnKeyUp', 'destinatarios_searchKeyUp');
    btnDestinatariosTab.SetParentComponent(Self);
    btnDestinatariosTab.Name := 'btnDestinatariosTab';
    btnDestinatariosTab.Left := 583;
    btnDestinatariosTab.Top := 31;
    btnDestinatariosTab.Width := 96;
    btnDestinatariosTab.Height := 25;
    btnDestinatariosTab.Caption := 'Destinat'#225'rios';
    btnDestinatariosTab.ChildOrder := 16;
    btnDestinatariosTab.HeightPercent := 100.000000000000000000;
    btnDestinatariosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnDestinatariosTab, Self, 'OnClick', 'btnDestinatariosTabClick');
    tblDestinatarios.SetParentComponent(Self);
    tblDestinatarios.Name := 'tblDestinatarios';
    tblDestinatarios.Left := 344;
    tblDestinatarios.Top := 88;
    tblDestinatarios.Width := 335;
    tblDestinatarios.Height := 143;
    tblDestinatarios.ElementClassName := 'table-responsive';
    tblDestinatarios.BorderColor := clSilver;
    tblDestinatarios.ChildOrder := 19;
    tblDestinatarios.ColHeader := False;
    tblDestinatarios.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblDestinatarios, Self, 'OnGetCellData', 'tblDestinatariosGetCellData');
    SetEvent(tblDestinatarios, Self, 'OnGetCellChildren', 'tblDestinatariosGetCellChildren');
    SetEvent(tblDestinatarios, Self, 'OnGetCellClass', 'tblDestinatariosGetCellClass');
    tblDestinatarios.Columns.Clear;
    with tblDestinatarios.Columns.Add do
    begin
      Title := 'A'#231#245'es';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.aliado_id';
      Title := 'C'#243'd. Aliado';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.aliado.CNPJ';
      Title := 'Cnpj';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'status';
      Title := 'Status';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.id';
      Title := 'C'#243'd. Banco';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.token';
      Title := 'Token Banco';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_base.path';
      Title := 'Caminho Banco';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'data_execucao';
      Title := 'Execu'#231#227'o';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblDestinatarios.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    tblDestinatarios.DataSource := dtsDestinatarios;
    wlcDestinatarios.SetParentComponent(Self);
    wlcDestinatarios.Name := 'wlcDestinatarios';
    wlcDestinatarios.Left := 472;
    wlcDestinatarios.Top := 237;
    wlcDestinatarios.Width := 207;
    wlcDestinatarios.Height := 15;
    wlcDestinatarios.HeightPercent := 100.000000000000000000;
    wlcDestinatarios.WidthPercent := 100.000000000000000000;
    wlcDestinatarios.ChildOrder := 24;
    wlcDestinatarios.DefaultItemClassName := 'page-item';
    wlcDestinatarios.DefaultItemLinkClassName := 'page-link';
    wlcDestinatarios.ElementListClassName := 'pagination';
    wlcDestinatarios.Items.Clear;
    with wlcDestinatarios.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcDestinatarios.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcDestinatarios.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcDestinatarios.Style := lsPagination;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 737;
    WebPanel3.Top := 8;
    WebPanel3.Width := 353;
    WebPanel3.Height := 17;
    WebPanel3.Caption := 'Espa'#231'o tabela aliados';
    WebPanel3.ChildOrder := 23;
    WebPanel3.Color := clInfoText;
    WebPanel3.Font.Charset := DEFAULT_CHARSET;
    WebPanel3.Font.Color := clWhite;
    WebPanel3.Font.Height := -11;
    WebPanel3.Font.Name := 'Tahoma';
    WebPanel3.Font.Style := [fsBold];
    WebPanel3.ParentFont := False;
    WebPanel3.TabOrder := 15;
    WebPanel3.Visible := False;
    cbPageSizeAliados.SetParentComponent(Self);
    cbPageSizeAliados.Name := 'cbPageSizeAliados';
    cbPageSizeAliados.Left := 889;
    cbPageSizeAliados.Top := 32;
    cbPageSizeAliados.Width := 81;
    cbPageSizeAliados.Height := 21;
    cbPageSizeAliados.HeightPercent := 100.000000000000000000;
    cbPageSizeAliados.TabOrder := 2;
    cbPageSizeAliados.Text := '10';
    cbPageSizeAliados.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeAliados, Self, 'OnChange', 'cbPageSizeAliadosChange');
    cbPageSizeAliados.ItemIndex := 0;
    cbPageSizeAliados.Items.BeginUpdate;
    try
      cbPageSizeAliados.Items.Clear;
      cbPageSizeAliados.Items.Add('10');
      cbPageSizeAliados.Items.Add('25');
      cbPageSizeAliados.Items.Add('50');
      cbPageSizeAliados.Items.Add('100');
    finally
      cbPageSizeAliados.Items.EndUpdate;
    end;
    aliados_search.SetParentComponent(Self);
    aliados_search.Name := 'aliados_search';
    aliados_search.Left := 889;
    aliados_search.Top := 59;
    aliados_search.Width := 81;
    aliados_search.Height := 21;
    aliados_search.ChildOrder := 21;
    aliados_search.HeightPercent := 100.000000000000000000;
    aliados_search.TabOrder := 3;
    aliados_search.WidthPercent := 100.000000000000000000;
    SetEvent(aliados_search, Self, 'OnKeyDown', 'aliados_searchKeyDown');
    SetEvent(aliados_search, Self, 'OnKeyUp', 'aliados_searchKeyUp');
    btnAdicionarAliado.SetParentComponent(Self);
    btnAdicionarAliado.Name := 'btnAdicionarAliado';
    btnAdicionarAliado.Left := 976;
    btnAdicionarAliado.Top := 31;
    btnAdicionarAliado.Width := 96;
    btnAdicionarAliado.Height := 25;
    btnAdicionarAliado.Caption := 'Selecionar Aliados';
    btnAdicionarAliado.ChildOrder := 16;
    btnAdicionarAliado.HeightPercent := 100.000000000000000000;
    btnAdicionarAliado.WidthPercent := 100.000000000000000000;
    SetEvent(btnAdicionarAliado, Self, 'OnClick', 'btnAdicionarAliadoClick');
    tblAliados.SetParentComponent(Self);
    tblAliados.Name := 'tblAliados';
    tblAliados.Left := 737;
    tblAliados.Top := 144;
    tblAliados.Width := 335;
    tblAliados.Height := 143;
    tblAliados.ElementClassName := 'table-responsive';
    tblAliados.BorderColor := clSilver;
    tblAliados.ChildOrder := 19;
    tblAliados.ColHeader := False;
    tblAliados.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAliados, Self, 'OnGetCellData', 'tblAliadosGetCellData');
    SetEvent(tblAliados, Self, 'OnGetCellChildren', 'tblAliadosGetCellChildren');
    SetEvent(tblAliados, Self, 'OnGetCellClass', 'tblAliadosGetCellClass');
    tblAliados.Columns.Clear;
    with tblAliados.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'C'#243'd. Aliado';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.CNPJ';
      Title := 'Cnpj';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd. Banco';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'token';
      Title := 'Token';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'path';
      Title := 'Caminho';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'fiscal';
      Title := 'Fiscal';
    end;
    tblAliados.DataSource := dtsAliados;
    wlcAliados.SetParentComponent(Self);
    wlcAliados.Name := 'wlcAliados';
    wlcAliados.Left := 865;
    wlcAliados.Top := 293;
    wlcAliados.Width := 207;
    wlcAliados.Height := 15;
    wlcAliados.HeightPercent := 100.000000000000000000;
    wlcAliados.WidthPercent := 100.000000000000000000;
    wlcAliados.ChildOrder := 24;
    wlcAliados.DefaultItemClassName := 'page-item';
    wlcAliados.DefaultItemLinkClassName := 'page-link';
    wlcAliados.ElementListClassName := 'pagination';
    wlcAliados.Items.Clear;
    with wlcAliados.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcAliados.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcAliados.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcAliados.Style := lsPagination;
    div_campos_visualizar.SetParentComponent(Self);
    div_campos_visualizar.Name := 'div_campos_visualizar';
    div_campos_visualizar.Left := 8;
    div_campos_visualizar.Top := 83;
    div_campos_visualizar.Width := 185;
    div_campos_visualizar.Height := 49;
    div_campos_visualizar.ChildOrder := 32;
    div_campos_visualizar.Role := '';
    div_campos_visualizar.Visible := False;
    lbscript_s3.SetParentComponent(div_campos_visualizar);
    lbscript_s3.Name := 'lbscript_s3';
    lbscript_s3.Left := 8;
    lbscript_s3.Top := 6;
    lbscript_s3.Width := 59;
    lbscript_s3.Height := 13;
    lbscript_s3.Caption := 'Caminho s3:';
    lbscript_s3.HeightPercent := 100.000000000000000000;
    lbscript_s3.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(div_campos_visualizar);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 8;
    lbinclusao.Top := 28;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    edscript_s3.SetParentComponent(div_campos_visualizar);
    edscript_s3.Name := 'edscript_s3';
    edscript_s3.Left := 67;
    edscript_s3.Top := 3;
    edscript_s3.Width := 99;
    edscript_s3.Height := 21;
    edscript_s3.ChildOrder := 1;
    edscript_s3.Enabled := False;
    edscript_s3.HeightPercent := 100.000000000000000000;
    edscript_s3.TabOrder := 8;
    edscript_s3.Text := 'edscript_s3';
    edscript_s3.WidthPercent := 100.000000000000000000;
    edscript_s3.DataField := 'script_s3';
    edscript_s3.DataSource := DataSource;
    edinclusao.SetParentComponent(div_campos_visualizar);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 74;
    edinclusao.Top := 20;
    edinclusao.Width := 92;
    edinclusao.Height := 21;
    edinclusao.ChildOrder := 3;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 8;
    WebPanel4.Top := 320;
    WebPanel4.Width := 305;
    WebPanel4.Height := 17;
    WebPanel4.Caption := 'Espa'#231'o tabela destinat'#225'rios edit';
    WebPanel4.ChildOrder := 23;
    WebPanel4.Color := clInfoText;
    WebPanel4.Font.Charset := DEFAULT_CHARSET;
    WebPanel4.Font.Color := clWhite;
    WebPanel4.Font.Height := -11;
    WebPanel4.Font.Name := 'Tahoma';
    WebPanel4.Font.Style := [fsBold];
    WebPanel4.ParentFont := False;
    WebPanel4.TabOrder := 22;
    WebPanel4.Visible := False;
    tblDestinatariosEdit.SetParentComponent(Self);
    tblDestinatariosEdit.Name := 'tblDestinatariosEdit';
    tblDestinatariosEdit.Left := 8;
    tblDestinatariosEdit.Top := 390;
    tblDestinatariosEdit.Width := 305;
    tblDestinatariosEdit.Height := 143;
    tblDestinatariosEdit.ElementClassName := 'table-responsive';
    tblDestinatariosEdit.BorderColor := clSilver;
    tblDestinatariosEdit.ChildOrder := 19;
    tblDestinatariosEdit.ColHeader := False;
    tblDestinatariosEdit.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblDestinatariosEdit, Self, 'OnGetCellData', 'tblDestinatariosEditGetCellData');
    SetEvent(tblDestinatariosEdit, Self, 'OnGetCellChildren', 'tblDestinatariosEditGetCellChildren');
    SetEvent(tblDestinatariosEdit, Self, 'OnGetCellClass', 'tblDestinatariosEditGetCellClass');
    tblDestinatariosEdit.Columns.Clear;
    with tblDestinatariosEdit.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'C'#243'd. Aliado';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'nome_fantasia';
      Title := 'Aliado';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'cnpj';
      Title := 'Cnpj';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'C'#243'd. Banco';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'token';
      Title := 'Token';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'path';
      Title := 'Caminho';
    end;
    with tblDestinatariosEdit.Columns.Add do
    begin
      DataField := 'fiscal';
      Title := 'fiscal';
    end;
    tblDestinatariosEdit.DataSource := dtsDestinatariosEdit;
    edtScriptErro.SetParentComponent(Self);
    edtScriptErro.Name := 'edtScriptErro';
    edtScriptErro.Left := 344;
    edtScriptErro.Top := 258;
    edtScriptErro.Width := 121;
    edtScriptErro.Height := 22;
    edtScriptErro.ChildOrder := 31;
    edtScriptErro.Enabled := False;
    edtScriptErro.HeightPercent := 100.000000000000000000;
    edtScriptErro.Text := 'edtScriptErro';
    edtScriptErro.WidthPercent := 100.000000000000000000;
    cbbScriptStatus.SetParentComponent(Self);
    cbbScriptStatus.Name := 'cbbScriptStatus';
    cbbScriptStatus.Left := 471;
    cbbScriptStatus.Top := 258;
    cbbScriptStatus.Width := 145;
    cbbScriptStatus.Height := 21;
    cbbScriptStatus.HeightPercent := 100.000000000000000000;
    cbbScriptStatus.Text := 'TODOS';
    cbbScriptStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbScriptStatus, Self, 'OnChange', 'cbbScriptStatusChange');
    cbbScriptStatus.ItemIndex := 0;
    cbbScriptStatus.Items.BeginUpdate;
    try
      cbbScriptStatus.Items.Clear;
      cbbScriptStatus.Items.Add('TODOS');
      cbbScriptStatus.Items.Add('CADASTRADOS');
      cbbScriptStatus.Items.Add('EXECUTADOS');
      cbbScriptStatus.Items.Add('ERRO');
    finally
      cbbScriptStatus.Items.EndUpdate;
    end;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 45;
    ednome.Top := 222;
    ednome.Width := 123;
    ednome.Height := 21;
    ednome.CharCase := wecUpperCase;
    ednome.ChildOrder := 34;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edscript_versao_minima.SetParentComponent(Self);
    edscript_versao_minima.Name := 'edscript_versao_minima';
    edscript_versao_minima.Left := 84;
    edscript_versao_minima.Top := 249;
    edscript_versao_minima.Width := 123;
    edscript_versao_minima.Height := 21;
    edscript_versao_minima.ChildOrder := 34;
    edscript_versao_minima.Enabled := False;
    edscript_versao_minima.HeightPercent := 100.000000000000000000;
    edscript_versao_minima.TabOrder := 7;
    edscript_versao_minima.Text := 'edscript_versao_minima';
    edscript_versao_minima.WidthPercent := 100.000000000000000000;
    edscript_versao_minima.DataField := 'script_versao_minima';
    edscript_versao_minima.DataSource := DataSource;
    edobservacao.SetParentComponent(Self);
    edobservacao.Name := 'edobservacao';
    edobservacao.Left := 246;
    edobservacao.Top := 58;
    edobservacao.Width := 67;
    edobservacao.Height := 21;
    edobservacao.ChildOrder := 34;
    edobservacao.HeightPercent := 100.000000000000000000;
    edobservacao.TabOrder := 7;
    edobservacao.Text := 'edobservacao';
    edobservacao.WidthPercent := 100.000000000000000000;
    SetEvent(edobservacao, Self, 'OnClick', 'ednomeClick');
    edobservacao.DataField := 'observacao';
    edobservacao.DataSource := DataSource;
    btAdicionarTodos.SetParentComponent(Self);
    btAdicionarTodos.Name := 'btAdicionarTodos';
    btAdicionarTodos.Left := 976;
    btAdicionarTodos.Top := 57;
    btAdicionarTodos.Width := 96;
    btAdicionarTodos.Height := 25;
    btAdicionarTodos.Caption := 'Adicionar Todos';
    btAdicionarTodos.ChildOrder := 16;
    btAdicionarTodos.HeightPercent := 100.000000000000000000;
    btAdicionarTodos.WidthPercent := 100.000000000000000000;
    SetEvent(btAdicionarTodos, Self, 'OnClick', 'btAdicionarTodosClick');
    cbVersaoMinima.SetParentComponent(Self);
    cbVersaoMinima.Name := 'cbVersaoMinima';
    cbVersaoMinima.Left := 213;
    cbVersaoMinima.Top := 249;
    cbVersaoMinima.Width := 97;
    cbVersaoMinima.Height := 21;
    cbVersaoMinima.HeightPercent := 100.000000000000000000;
    cbVersaoMinima.Text := 'cbVersaoMinima';
    cbVersaoMinima.WidthPercent := 100.000000000000000000;
    SetEvent(cbVersaoMinima, Self, 'OnClick', 'cbVersaoMinimaClick');
    cbVersaoMinima.ItemIndex := -1;
    cbVersaoMinima.DataField := 'nome';
    cbVersaoMinima.DataSource := dtsVersoes;
    cbVersaoMinima.ListField := 'nome';
    cbVersaoMinima.ListSource := dtsVersoes;
    btnListagemBancos.SetParentComponent(Self);
    btnListagemBancos.Name := 'btnListagemBancos';
    btnListagemBancos.Left := 976;
    btnListagemBancos.Top := 88;
    btnListagemBancos.Width := 96;
    btnListagemBancos.Height := 25;
    btnListagemBancos.Caption := 'Adicionar Aliado';
    btnListagemBancos.ChildOrder := 41;
    btnListagemBancos.HeightPercent := 100.000000000000000000;
    btnListagemBancos.WidthPercent := 100.000000000000000000;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ScriptsDataset;
    DataSource.Left := 656;
    DataSource.Top := 544;
    ScriptsDataset.SetParentComponent(Self);
    ScriptsDataset.Name := 'ScriptsDataset';
    ScriptsDataset.AfterApplyUpdates := ScriptsDatasetAfterApplyUpdates;
    ScriptsDataset.EntitySetName := 'Scripts';
    ScriptsDataset.Connection := DMConnection.ApiConnection;
    ScriptsDataset.Left := 752;
    ScriptsDataset.Top := 544;
    ScriptsDatasetid.SetParentComponent(ScriptsDataset);
    ScriptsDatasetid.Name := 'ScriptsDatasetid';
    ScriptsDatasetid.FieldName := 'id';
    ScriptsDatasetusuario_id.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuario_id.Name := 'ScriptsDatasetusuario_id';
    ScriptsDatasetusuario_id.FieldName := 'usuario_id';
    ScriptsDatasetscript_s3.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_s3.Name := 'ScriptsDatasetscript_s3';
    ScriptsDatasetscript_s3.FieldName := 'script_s3';
    ScriptsDatasetscript_s3.Required := True;
    ScriptsDatasetscript_s3.Size := 255;
    ScriptsDatasetscript_geral.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_geral.Name := 'ScriptsDatasetscript_geral';
    ScriptsDatasetscript_geral.FieldName := 'script_geral';
    ScriptsDatasetscript_geral.Required := True;
    ScriptsDatasetinclusao.SetParentComponent(ScriptsDataset);
    ScriptsDatasetinclusao.Name := 'ScriptsDatasetinclusao';
    ScriptsDatasetinclusao.FieldName := 'inclusao';
    ScriptsDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ScriptsDatasetscript_tipo.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_tipo.Name := 'ScriptsDatasetscript_tipo';
    ScriptsDatasetscript_tipo.FieldName := 'script_tipo';
    ScriptsDatasetscript_tipo.Required := True;
    ScriptsDatasetusuario.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuario.Name := 'ScriptsDatasetusuario';
    ScriptsDatasetusuario.FieldName := 'usuario';
    ScriptsDatasetusuarionome.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuarionome.Name := 'ScriptsDatasetusuarionome';
    ScriptsDatasetusuarionome.FieldKind := fkCalculated;
    ScriptsDatasetusuarionome.FieldName := 'usuario.nome';
    SetEvent(ScriptsDatasetusuarionome, Self, 'OnGetText', 'ScriptsDatasetusuarionomeGetText');
    ScriptsDatasetusuarionome.Calculated := True;
    ScriptsDatasetnome.SetParentComponent(ScriptsDataset);
    ScriptsDatasetnome.Name := 'ScriptsDatasetnome';
    ScriptsDatasetnome.FieldName := 'nome';
    ScriptsDatasetnome.Required := True;
    ScriptsDatasetnome.Size := 255;
    ScriptsDatasetscript_versao_minima.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_versao_minima.Name := 'ScriptsDatasetscript_versao_minima';
    ScriptsDatasetscript_versao_minima.FieldName := 'script_versao_minima';
    ScriptsDatasetscript_versao_minima.Size := 255;
    ScriptsDatasetobservacao.SetParentComponent(ScriptsDataset);
    ScriptsDatasetobservacao.Name := 'ScriptsDatasetobservacao';
    ScriptsDatasetobservacao.FieldName := 'observacao';
    ScriptsDatasetobservacao.Size := 255;
    XDataClientScriptsGet.SetParentComponent(Self);
    XDataClientScriptsGet.Name := 'XDataClientScriptsGet';
    XDataClientScriptsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientScriptsGet, Self, 'OnLoad', 'XDataClientScriptsGetLoad');
    XDataClientScriptsGet.Left := 848;
    XDataClientScriptsGet.Top := 544;
    dtsDestinatarios.SetParentComponent(Self);
    dtsDestinatarios.Name := 'dtsDestinatarios';
    dtsDestinatarios.DataSet := cdsDestinatarios;
    dtsDestinatarios.Left := 352;
    dtsDestinatarios.Top := 40;
    cdsDestinatarios.SetParentComponent(Self);
    cdsDestinatarios.Name := 'cdsDestinatarios';
    cdsDestinatarios.EntitySetName := 'Scripts_Aliados';
    cdsDestinatarios.Connection := DMConnection.ApiConnection;
    cdsDestinatarios.Left := 424;
    cdsDestinatarios.Top := 40;
    cdsDestinatariosid.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosid.Name := 'cdsDestinatariosid';
    cdsDestinatariosid.FieldName := 'id';
    cdsDestinatariosid.Required := True;
    cdsDestinatariosscript_id.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosscript_id.Name := 'cdsDestinatariosscript_id';
    cdsDestinatariosscript_id.FieldName := 'script_id';
    cdsDestinatariosscript_id.Required := True;
    cdsDestinatariosstatus.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosstatus.Name := 'cdsDestinatariosstatus';
    cdsDestinatariosstatus.FieldName := 'status';
    cdsDestinatariosstatus.Required := True;
    cdsDestinatarioserro.SetParentComponent(cdsDestinatarios);
    cdsDestinatarioserro.Name := 'cdsDestinatarioserro';
    cdsDestinatarioserro.FieldName := 'erro';
    cdsDestinatarioserro.Size := 255;
    cdsDestinatariosinclusao.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosinclusao.Name := 'cdsDestinatariosinclusao';
    cdsDestinatariosinclusao.FieldName := 'inclusao';
    cdsDestinatariosinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDestinatariosalteracao.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosalteracao.Name := 'cdsDestinatariosalteracao';
    cdsDestinatariosalteracao.FieldName := 'alteracao';
    cdsDestinatariosalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDestinatariosdata_base.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_base.Name := 'cdsDestinatariosdata_base';
    cdsDestinatariosdata_base.FieldName := 'data_base';
    cdsDestinatariosdata_basealiadoNome_Fantasia.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_basealiadoNome_Fantasia.Name := 'cdsDestinatariosdata_basealiadoNome_Fantasia';
    cdsDestinatariosdata_basealiadoNome_Fantasia.FieldName := 'data_base.aliado.Nome_Fantasia';
    cdsDestinatariosdata_basealiadoCNPJ.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_basealiadoCNPJ.Name := 'cdsDestinatariosdata_basealiadoCNPJ';
    cdsDestinatariosdata_basealiadoCNPJ.FieldName := 'data_base.aliado.CNPJ';
    cdsDestinatariosdata_basetoken.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_basetoken.Name := 'cdsDestinatariosdata_basetoken';
    cdsDestinatariosdata_basetoken.FieldName := 'data_base.token';
    cdsDestinatariosdata_basepath.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_basepath.Name := 'cdsDestinatariosdata_basepath';
    cdsDestinatariosdata_basepath.FieldName := 'data_base.path';
    cdsDestinatariosdata_execucao.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_execucao.Name := 'cdsDestinatariosdata_execucao';
    cdsDestinatariosdata_execucao.FieldName := 'data_execucao';
    cdsDestinatariosdata_execucao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDestinatariosdata_baseid.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_baseid.Name := 'cdsDestinatariosdata_baseid';
    cdsDestinatariosdata_baseid.FieldKind := fkCalculated;
    cdsDestinatariosdata_baseid.FieldName := 'data_base.id';
    cdsDestinatariosdata_baseid.Calculated := True;
    cdsDestinatariosdata_basealiado_id.SetParentComponent(cdsDestinatarios);
    cdsDestinatariosdata_basealiado_id.Name := 'cdsDestinatariosdata_basealiado_id';
    cdsDestinatariosdata_basealiado_id.FieldKind := fkCalculated;
    cdsDestinatariosdata_basealiado_id.FieldName := 'data_base.aliado_id';
    cdsDestinatariosdata_basealiado_id.Calculated := True;
    tmrConsultaDestinatarios.SetParentComponent(Self);
    tmrConsultaDestinatarios.Name := 'tmrConsultaDestinatarios';
    tmrConsultaDestinatarios.Enabled := False;
    SetEvent(tmrConsultaDestinatarios, Self, 'OnTimer', 'tmrConsultaDestinatariosTimer');
    tmrConsultaDestinatarios.Left := 400;
    tmrConsultaDestinatarios.Top := 120;
    dtsAliados.SetParentComponent(Self);
    dtsAliados.Name := 'dtsAliados';
    dtsAliados.DataSet := cdsAliados;
    dtsAliados.Left := 745;
    dtsAliados.Top := 40;
    cdsAliados.SetParentComponent(Self);
    cdsAliados.Name := 'cdsAliados';
    cdsAliados.EntitySetName := 'data_base';
    cdsAliados.Connection := DMConnection.ApiConnection;
    cdsAliados.Left := 817;
    cdsAliados.Top := 40;
    cdsAliadosid.SetParentComponent(cdsAliados);
    cdsAliadosid.Name := 'cdsAliadosid';
    cdsAliadosid.FieldName := 'id';
    cdsAliadosid.Required := True;
    cdsAliadostoken.SetParentComponent(cdsAliados);
    cdsAliadostoken.Name := 'cdsAliadostoken';
    cdsAliadostoken.FieldName := 'token';
    cdsAliadostoken.Required := True;
    cdsAliadostoken.Size := 256;
    cdsAliadosfiscal.SetParentComponent(cdsAliados);
    cdsAliadosfiscal.Name := 'cdsAliadosfiscal';
    cdsAliadosfiscal.FieldName := 'fiscal';
    cdsAliadosfiscal.Required := True;
    cdsAliadosaliado_id.SetParentComponent(cdsAliados);
    cdsAliadosaliado_id.Name := 'cdsAliadosaliado_id';
    cdsAliadosaliado_id.FieldName := 'aliado_id';
    cdsAliadosaliado_id.Required := True;
    cdsAliadosaliado.SetParentComponent(cdsAliados);
    cdsAliadosaliado.Name := 'cdsAliadosaliado';
    cdsAliadosaliado.FieldName := 'aliado';
    cdsAliadosaliadoNome_Fantasia.SetParentComponent(cdsAliados);
    cdsAliadosaliadoNome_Fantasia.Name := 'cdsAliadosaliadoNome_Fantasia';
    cdsAliadosaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    cdsAliadosaliadoCNPJ.SetParentComponent(cdsAliados);
    cdsAliadosaliadoCNPJ.Name := 'cdsAliadosaliadoCNPJ';
    cdsAliadosaliadoCNPJ.FieldName := 'aliado.CNPJ';
    cdsAliadospath.SetParentComponent(cdsAliados);
    cdsAliadospath.Name := 'cdsAliadospath';
    cdsAliadospath.FieldName := 'path';
    cdsAliadospath.Size := 255;
    cdsAliadosadicionado.SetParentComponent(cdsAliados);
    cdsAliadosadicionado.Name := 'cdsAliadosadicionado';
    cdsAliadosadicionado.FieldKind := fkCalculated;
    cdsAliadosadicionado.FieldName := 'adicionado';
    cdsAliadosadicionado.Calculated := True;
    tmrConsultaAliados.SetParentComponent(Self);
    tmrConsultaAliados.Name := 'tmrConsultaAliados';
    tmrConsultaAliados.Enabled := False;
    SetEvent(tmrConsultaAliados, Self, 'OnTimer', 'tmrConsultaAliadosTimer');
    tmrConsultaAliados.Left := 776;
    tmrConsultaAliados.Top := 168;
    XDataWebClientObterScript.SetParentComponent(Self);
    XDataWebClientObterScript.Name := 'XDataWebClientObterScript';
    XDataWebClientObterScript.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientObterScript, Self, 'OnLoad', 'XDataWebClientObterScriptLoad');
    SetEvent(XDataWebClientObterScript, Self, 'OnError', 'XDataWebClientObterScriptError');
    XDataWebClientObterScript.Left := 936;
    XDataWebClientObterScript.Top := 544;
    dtsDestinatariosEdit.SetParentComponent(Self);
    dtsDestinatariosEdit.Name := 'dtsDestinatariosEdit';
    dtsDestinatariosEdit.DataSet := cdsDestinatariosEdit;
    dtsDestinatariosEdit.Left := 48;
    dtsDestinatariosEdit.Top := 344;
    cdsDestinatariosEdit.SetParentComponent(Self);
    cdsDestinatariosEdit.Name := 'cdsDestinatariosEdit';
    cdsDestinatariosEdit.EntitySetName := 'Scripts_Aliados';
    cdsDestinatariosEdit.Connection := DMConnection.ApiConnection;
    cdsDestinatariosEdit.Left := 152;
    cdsDestinatariosEdit.Top := 344;
    cdsDestinatariosEditscript_id.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditscript_id.Name := 'cdsDestinatariosEditscript_id';
    cdsDestinatariosEditscript_id.FieldName := 'script_id';
    cdsDestinatariosEditaliado_id.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditaliado_id.Name := 'cdsDestinatariosEditaliado_id';
    cdsDestinatariosEditaliado_id.FieldName := 'aliado_id';
    cdsDestinatariosEditaliado_id.Required := True;
    cdsDestinatariosEditdata_base_id.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditdata_base_id.Name := 'cdsDestinatariosEditdata_base_id';
    cdsDestinatariosEditdata_base_id.FieldName := 'data_base_id';
    cdsDestinatariosEditdata_base_id.Required := True;
    cdsDestinatariosEditnome_fantasia.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditnome_fantasia.Name := 'cdsDestinatariosEditnome_fantasia';
    cdsDestinatariosEditnome_fantasia.FieldKind := fkCalculated;
    cdsDestinatariosEditnome_fantasia.FieldName := 'nome_fantasia';
    cdsDestinatariosEditnome_fantasia.Calculated := True;
    cdsDestinatariosEditcnpj.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditcnpj.Name := 'cdsDestinatariosEditcnpj';
    cdsDestinatariosEditcnpj.FieldKind := fkCalculated;
    cdsDestinatariosEditcnpj.FieldName := 'cnpj';
    cdsDestinatariosEditcnpj.Calculated := True;
    cdsDestinatariosEdittoken.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEdittoken.Name := 'cdsDestinatariosEdittoken';
    cdsDestinatariosEdittoken.FieldKind := fkCalculated;
    cdsDestinatariosEdittoken.FieldName := 'token';
    cdsDestinatariosEdittoken.Calculated := True;
    cdsDestinatariosEditpath.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditpath.Name := 'cdsDestinatariosEditpath';
    cdsDestinatariosEditpath.FieldKind := fkCalculated;
    cdsDestinatariosEditpath.FieldName := 'path';
    cdsDestinatariosEditpath.Calculated := True;
    cdsDestinatariosEditfiscal.SetParentComponent(cdsDestinatariosEdit);
    cdsDestinatariosEditfiscal.Name := 'cdsDestinatariosEditfiscal';
    cdsDestinatariosEditfiscal.FieldKind := fkCalculated;
    cdsDestinatariosEditfiscal.FieldName := 'fiscal';
    cdsDestinatariosEditfiscal.Calculated := True;
    XDataWebClientReexecutarScript.SetParentComponent(Self);
    XDataWebClientReexecutarScript.Name := 'XDataWebClientReexecutarScript';
    XDataWebClientReexecutarScript.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientReexecutarScript, Self, 'OnLoad', 'XDataWebClientReexecutarScriptLoad');
    SetEvent(XDataWebClientReexecutarScript, Self, 'OnError', 'XDataWebClientReexecutarScriptError');
    XDataWebClientReexecutarScript.Left := 920;
    XDataWebClientReexecutarScript.Top := 464;
    dtsVersoes.SetParentComponent(Self);
    dtsVersoes.Name := 'dtsVersoes';
    dtsVersoes.DataSet := cdsVersoes;
    dtsVersoes.Left := 456;
    dtsVersoes.Top := 552;
    cdsVersoes.SetParentComponent(Self);
    cdsVersoes.Name := 'cdsVersoes';
    cdsVersoes.AfterOpen := cdsVersoesAfterOpen;
    cdsVersoes.EntitySetName := 'Versoes';
    cdsVersoes.Connection := DMConnection.ApiConnection;
    cdsVersoes.QueryString := '$orderby=nome desc';
    cdsVersoes.Left := 520;
    cdsVersoes.Top := 544;
    cdsVersoesnome.SetParentComponent(cdsVersoes);
    cdsVersoesnome.Name := 'cdsVersoesnome';
    cdsVersoesnome.FieldName := 'nome';
    cdsVersoesnome.Required := True;
    cdsVersoesnome.Size := 255;
  finally
    lbid.AfterLoadDFMValues;
    lbusuario_id.AfterLoadDFMValues;
    lbscript_geral.AfterLoadDFMValues;
    lbscript_tipo.AfterLoadDFMValues;
    lbscript_texto.AfterLoadDFMValues;
    lbTotalDestinatarios.AfterLoadDFMValues;
    lbTotalAliados.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbscript_versao_minima.AfterLoadDFMValues;
    lbobservacao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edusuario_nome.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnTabScript.AfterLoadDFMValues;
    cbscript_geral.AfterLoadDFMValues;
    cbscript_tipo.AfterLoadDFMValues;
    mmscript_texto.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    cbPageSizeDestinatarios.AfterLoadDFMValues;
    destinatarios_search.AfterLoadDFMValues;
    btnDestinatariosTab.AfterLoadDFMValues;
    tblDestinatarios.AfterLoadDFMValues;
    wlcDestinatarios.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    cbPageSizeAliados.AfterLoadDFMValues;
    aliados_search.AfterLoadDFMValues;
    btnAdicionarAliado.AfterLoadDFMValues;
    tblAliados.AfterLoadDFMValues;
    wlcAliados.AfterLoadDFMValues;
    div_campos_visualizar.AfterLoadDFMValues;
    lbscript_s3.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edscript_s3.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    tblDestinatariosEdit.AfterLoadDFMValues;
    edtScriptErro.AfterLoadDFMValues;
    cbbScriptStatus.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edscript_versao_minima.AfterLoadDFMValues;
    edobservacao.AfterLoadDFMValues;
    btAdicionarTodos.AfterLoadDFMValues;
    cbVersaoMinima.AfterLoadDFMValues;
    btnListagemBancos.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ScriptsDataset.AfterLoadDFMValues;
    ScriptsDatasetid.AfterLoadDFMValues;
    ScriptsDatasetusuario_id.AfterLoadDFMValues;
    ScriptsDatasetscript_s3.AfterLoadDFMValues;
    ScriptsDatasetscript_geral.AfterLoadDFMValues;
    ScriptsDatasetinclusao.AfterLoadDFMValues;
    ScriptsDatasetscript_tipo.AfterLoadDFMValues;
    ScriptsDatasetusuario.AfterLoadDFMValues;
    ScriptsDatasetusuarionome.AfterLoadDFMValues;
    ScriptsDatasetnome.AfterLoadDFMValues;
    ScriptsDatasetscript_versao_minima.AfterLoadDFMValues;
    ScriptsDatasetobservacao.AfterLoadDFMValues;
    XDataClientScriptsGet.AfterLoadDFMValues;
    dtsDestinatarios.AfterLoadDFMValues;
    cdsDestinatarios.AfterLoadDFMValues;
    cdsDestinatariosid.AfterLoadDFMValues;
    cdsDestinatariosscript_id.AfterLoadDFMValues;
    cdsDestinatariosstatus.AfterLoadDFMValues;
    cdsDestinatarioserro.AfterLoadDFMValues;
    cdsDestinatariosinclusao.AfterLoadDFMValues;
    cdsDestinatariosalteracao.AfterLoadDFMValues;
    cdsDestinatariosdata_base.AfterLoadDFMValues;
    cdsDestinatariosdata_basealiadoNome_Fantasia.AfterLoadDFMValues;
    cdsDestinatariosdata_basealiadoCNPJ.AfterLoadDFMValues;
    cdsDestinatariosdata_basetoken.AfterLoadDFMValues;
    cdsDestinatariosdata_basepath.AfterLoadDFMValues;
    cdsDestinatariosdata_execucao.AfterLoadDFMValues;
    cdsDestinatariosdata_baseid.AfterLoadDFMValues;
    cdsDestinatariosdata_basealiado_id.AfterLoadDFMValues;
    tmrConsultaDestinatarios.AfterLoadDFMValues;
    dtsAliados.AfterLoadDFMValues;
    cdsAliados.AfterLoadDFMValues;
    cdsAliadosid.AfterLoadDFMValues;
    cdsAliadostoken.AfterLoadDFMValues;
    cdsAliadosfiscal.AfterLoadDFMValues;
    cdsAliadosaliado_id.AfterLoadDFMValues;
    cdsAliadosaliado.AfterLoadDFMValues;
    cdsAliadosaliadoNome_Fantasia.AfterLoadDFMValues;
    cdsAliadosaliadoCNPJ.AfterLoadDFMValues;
    cdsAliadospath.AfterLoadDFMValues;
    cdsAliadosadicionado.AfterLoadDFMValues;
    tmrConsultaAliados.AfterLoadDFMValues;
    XDataWebClientObterScript.AfterLoadDFMValues;
    dtsDestinatariosEdit.AfterLoadDFMValues;
    cdsDestinatariosEdit.AfterLoadDFMValues;
    cdsDestinatariosEditscript_id.AfterLoadDFMValues;
    cdsDestinatariosEditaliado_id.AfterLoadDFMValues;
    cdsDestinatariosEditdata_base_id.AfterLoadDFMValues;
    cdsDestinatariosEditnome_fantasia.AfterLoadDFMValues;
    cdsDestinatariosEditcnpj.AfterLoadDFMValues;
    cdsDestinatariosEdittoken.AfterLoadDFMValues;
    cdsDestinatariosEditpath.AfterLoadDFMValues;
    cdsDestinatariosEditfiscal.AfterLoadDFMValues;
    XDataWebClientReexecutarScript.AfterLoadDFMValues;
    dtsVersoes.AfterLoadDFMValues;
    cdsVersoes.AfterLoadDFMValues;
    cdsVersoesnome.AfterLoadDFMValues;
  end;
end;

end.
